/**
 * Zweck: Beschreibt class ArtikelNote und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/artikel-note.ts.
 */
export class ArtikelNote {
  id: number;
  note: string;
  artikelstamm: string;
  artnr: number;
  kunde_nr: string;
}
